import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-brand-green text-white">
        <p className="font-serif text-2xl">Chargement…</p>
      </div>
    );
  }
  if (!user || !user.is_admin) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
